import { OrderDetailsService } from './../../services/order-details/order-details.service';
import { routes } from './../../../dashboard/dashboard-routing.module';
import { BehaviorSubject } from 'rxjs';
import { AutofillEligibilityService } from './../../services/autofill-eligibility/autofill-eligibility.service';
import { LoginService } from './../../services/login/login.service';
import { localConsole } from './../../utils/local-console';
import { UiConfigService } from './../../config/ui-config/ui-config.service';
import * as i0 from "@angular/core";
import * as i1 from "../../services/order-details/order-details.service";
import * as i2 from "../../config/ui-config/ui-config.service";
import * as i3 from "../../services/autofill-eligibility/autofill-eligibility.service";
import * as i4 from "../../services/login/login.service";
export class TabsService {
    constructor(_orders, _uiConfig, _autofillEligibilty, _auth) {
        this._orders = _orders;
        this._uiConfig = _uiConfig;
        this._autofillEligibilty = _autofillEligibilty;
        this._auth = _auth;
        this.tabs = [];
        /**
         * Subscription available to onotify of tabs changes
         */
        this.asyncTabs = new BehaviorSubject(this.tabs);
        this.isAutoFillEligible = false;
        // subscribe to auto fill service to show hide settings tab based on eligibility
        this._autofillEligibilty.asyncSDEligibility.subscribe(eligible => {
            this.isAutoFillEligible = eligible && (eligible.autofillEnrolled || eligible.autofillEligible);
            localConsole.log('Auto fill eligible:', eligible);
            this.init();
        });
    }
    init() {
        this.tabs = routes.map(r => r.children
            .filter((route) => route.data && route.data.tab)
            .map(info => info.data).map(t => {
            const dynamicTab = Object.assign({ default: t.default }, t.label);
            if (t.label.name === 'medications') {
                const nextOrder = this._orders.currentBox();
                const ctn = (nextOrder
                    ? nextOrder.prescriptionInfo.length
                    : '');
                dynamicTab.dynValue = ctn ? ' (' + ctn + ')' : null;
            }
            (t.label.name === 'settings') && (this._orders.isAutofillReviewOrder || !this.isAutoFillEligible) ?
                dynamicTab.class = 'hide' : dynamicTab.class = '';
            return dynamicTab;
        }))[0];
        this.asyncTabs.next(this.tabs);
        return this;
    }
    // return default tab labels in app routing snapshot data
    getDefaultTab() {
        return this._uiConfig.defaultTabUrl || this.tabs.filter(t => t.default)[0].name || 'orders';
    }
}
TabsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TabsService_Factory() { return new TabsService(i0.ɵɵinject(i1.OrderDetailsService), i0.ɵɵinject(i2.UiConfigService), i0.ɵɵinject(i3.AutofillEligibilityService), i0.ɵɵinject(i4.LoginService)); }, token: TabsService, providedIn: "root" });
